import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawKeukenblokRedModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Keukenblok");

		this.name = "keukenblok-red";
		this.icon = svg_keukenblok_red;
		this.svgTextIndex = 5;
	}
}

window.customElements.define("inspx-draw-keukenblok-red-module", DrawKeukenblokRedModule);

const svg_keukenblok_red = (text) => html`
<svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="25.703865mm" height="11.656082mm" viewBox="0 0 25.703865 11.656082">
    <defs id="defs2517" />
    <g transform="translate(-78.618306,-107.47553)">
        <g id="g5261" transform="matrix(0.26458333,0,0,0.26458333,-84.301959,39.843367)">
            <rect ry="0" y="256.10013" x="616.24414" height="43.089481" width="96.183464" id="rect6156-5" style="fill:#ff0000;fill-opacity:0.98843934;stroke:#021801;stroke-width:0.96500343;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            />
            <rect ry="4.6636977" y="266.16916" x="634.43298" height="17.100225" width="28.805494" id="rect6158-1" style="fill:#ff0000;fill-opacity:0.98843934;stroke:#021801;stroke-width:1.07466543;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            />
            <path id="path6188-7" d="M 682.44214,266.16916 H 701.6458" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <path id="path6190-1" d="M 682.44214,274.71927 H 701.6458" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <path id="path6192-1" d="M 682.44214,283.26939 H 701.6458" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <text transform="scale(0.7599368,1.3158989)" id="text6200-5" y="224.23581" x="822.61536" style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:'Arial Bold';text-align:start;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
                xml:space="preserve">
                <tspan y="224.23581" x="822.61536" id="tspan6202-2" style="font-size:12.63503933px;line-height:1.25;stroke-width:1.06666672">${text}</tspan>
            </text>
        </g>
    </g>
</svg>`;
